export default (store, col) => {
    if (col.filterable) {
        store.commit('unsetFilter', {key: col.key});
        store.dispatch('saveState');
        store.dispatch('getData');
    }
}


// WEBPACK FOOTER //
// ./src/app/store/base/actions/remove-filter.js